import { IComponentOptions } from "angular";
import { ProcessNotificationEditController } from "./controller";
export const vsComponentName = "processActionEdit";
export const processNotificationEditComponentOptions: IComponentOptions = {
  controller: ProcessNotificationEditController,
  template: require("!html-loader!./index.html").default,
  controllerAs: "stateController",
  bindings: {
    model: "<",
    processGroups: "<",
  },
};
